<template>
  <div class="tn-tag" :class="type ? 'tn-tag--' + type : ''">{{title}}</div>
</template>
<script>
  export default {
    name: 'tn-tag',
    props: {
      title: [String, Number],
      type: String
    }
  };
</script>
